/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Status_Progress_SavedInputs */

const en_course_status_progress_saved = /** @type {(inputs: Course_Status_Progress_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progress is saved.`)
};

const ja_course_status_progress_saved = /** @type {(inputs: Course_Status_Progress_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`進捗は保存されています。`)
};

const fr_course_status_progress_saved = /** @type {(inputs: Course_Status_Progress_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La progression est sauvegardée.`)
};

const de_course_status_progress_saved = /** @type {(inputs: Course_Status_Progress_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortschritt wird gespeichert.`)
};

/**
* | output |
* | --- |
* | "Progress is saved." |
*
* @param {Course_Status_Progress_SavedInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const course_status_progress_saved = /** @type {((inputs?: Course_Status_Progress_SavedInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Status_Progress_SavedInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_course_status_progress_saved(inputs)
	if (locale === "ja") return ja_course_status_progress_saved(inputs)
	if (locale === "fr") return fr_course_status_progress_saved(inputs)
	return de_course_status_progress_saved(inputs)
});